import { EMakeAChoice } from "../../Enums/EMakeAChoice";
import { IPassword } from "./IPassword";

export interface IAdmin {
  id: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  lastActivity: Date;
  password: IPassword;
  customerId: number;
}

export class AdminFormValues {
  id?: string | undefined;
  email: string = "";
  userName: string = "";
  firstName: string = "";
  lastName: string = "";
  customerId: number = EMakeAChoice.Value;

  constructor(init?: IAdmin) {
    Object.assign(this, init);
  }
}